'use client';

import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="pt-6">
      <h1 className="text-3xl font-bold text-color-1 mb-6 text-center">
        Privacy Policy
      </h1>
      <p className="mb-6">
        At <span className="font-semibold">Centera Tech</span>, we are committed
        to protecting your privacy and ensuring the security of your personal
        information. This Privacy Policy explains how we collect, use, and
        safeguard your information when you visit our website or use our
        services.
      </p>

      {/* Information Collection */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-color-1 mb-4">
          1. Information We Collect
        </h2>
        <ul className="list-disc ml-6">
          <li>
            <span className="font-semibold">Personal Information:</span> Your
            name, email address, phone number, and other contact details
            provided through our forms or while using our services.
          </li>
          <li>
            <span className="font-semibold">Technical Information:</span> Data
            such as IP address, browser type, operating system, and usage
            patterns collected through cookies and analytics tools.
          </li>
          <li>
            <span className="font-semibold">Service-Related Information:</span>{" "}
            Details about the software or services you use, including
            preferences and support requests.
          </li>
        </ul>
      </section>

      {/* Use of Information */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-color-1 mb-4">
          2. How We Use Your Information
        </h2>
        <ul className="list-disc ml-6">
          <li>To provide, maintain, and improve our software and services.</li>
          <li>To respond to inquiries, support requests, or feedback.</li>
          <li>
            To communicate updates, promotions, or service-related
            notifications.
          </li>
          <li>To analyze and enhance user experience through data insights.</li>
        </ul>
      </section>

      {/* Sharing of Information */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-color-1 mb-4">
          3. Information Sharing
        </h2>
        <p>
          We do not sell or rent your personal information to third parties.
          However, we may share your data with:
        </p>
        <ul className="list-disc ml-6">
          <li>
            <span className="font-semibold">Service Providers:</span> Trusted
            third-party partners for hosting, analytics, and other necessary
            services.
          </li>
          <li>
            <span className="font-semibold">Legal Compliance:</span> Authorities
            or entities if required by law or to protect our legal rights.
          </li>
        </ul>
      </section>

      {/* Data Security */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-color-1 mb-4">
          4. Data Security
        </h2>
        <p>
          We use industry-standard measures to protect your information from
          unauthorized access, loss, or misuse. However, no method of
          transmission or storage is completely secure, and we cannot guarantee
          absolute security.
        </p>
      </section>

      {/* Cookies and Tracking */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-color-1 mb-4">
          5. Cookies and Tracking Technologies
        </h2>
        <p>
          Our website uses cookies to enhance user experience and gather
          analytics. You can manage your cookie preferences through your browser
          settings.
        </p>
      </section>

      {/* User Rights */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-color-1 mb-4">
          6. Your Rights
        </h2>
        <ul className="list-disc ml-6">
          <li>Access, update, or delete your personal information.</li>
          <li>Opt-out of promotional communications.</li>
          <li>Request details on how your data is used.</li>
        </ul>
        <p className="mt-4">
          To exercise these rights, please contact us at{" "}
          <span className="font-semibold">support@centera.tech</span>.
        </p>
      </section>

      {/* Updates to Policy */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-color-1 mb-4">
          7. Changes to This Policy
        </h2>
        <p>
          Centera Tech may update this Privacy Policy periodically. We encourage
          you to review this page regularly for updates. Continued use of our
          services constitutes acceptance of the updated policy.
        </p>
      </section>

      {/* Contact Information */}
      <section>
        <h2 className="text-2xl font-semibold text-color-1 mb-4">
          8. Contact Us
        </h2>
        <p>
          If you have any questions about this Privacy Policy or how your data
          is handled, please contact us:
        </p>
        <address className="mt-4 not-italic">
          <p>
            Email:{" "}
            <a
              href="mailto:support@centera.tech"
              className="text-color-1 underline"
            >
              support@centera.tech
            </a>
          </p>
          {/* <p>Phone: +1-234-567-890</p>
          <p>Address: 123 Innovation Drive, TechCity, USA</p> */}
        </address>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
